export default {
  subdomain: 'amm',
  // sso: {
  //   protocol: 'openIDConnect',
  //   login: 'https://login.microsoftonline.com/ac120b75-41de-4188-8b01-8b07d7a0ce4a/oauth2/v2.0/authorize?client_id=55bb3a7c-e081-4403-b362-9e5f5b43d643&response_type=code&scope=openid%20email%20profile&redirect_uri=https%3A%2F%2Famm.bubbleplan.net',
  //   response_type: 'code',
  // },
  hideManageAccount: true,
};
